/**
 * TanStack Query hooks for `creative-hosting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	listByCampaign,
	remove,
	creativeHostingQueryKeys,
	type CreateCreativeHostingBody,
	type ListCreativeHostingResponse,
	type CreativeHostingRow,
} from "./api";

export function useCreativeHostingList(
	campaignId: string,
): UseQueryResult<ListCreativeHostingResponse, Error> {
	return useQuery({
		queryKey: creativeHostingQueryKeys.list(campaignId),
		queryFn: () => listByCampaign(campaignId),
		enabled: campaignId.trim().length > 0,
	});
}

export function useCreativeHostingCreate(): UseMutationResult<
	CreativeHostingRow,
	Error,
	CreateCreativeHostingBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeHostingQueryKeys.all });
		},
	});
}

export function useCreativeHostingDelete(): UseMutationResult<
	{ ok: boolean; id: string },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: creativeHostingQueryKeys.all });
		},
	});
}
